import { createUseStyles } from "react-jss";
import { foregroundColor, darken, alpha } from "../../theme/Mixins";

export default createUseStyles({
    container: {
        position: "relative",
        userSelect: "none",
    },
    group: {
        position: "absolute",
        textAlign: "center",
        fontWeight: "bolder",
    },
    bucket: {
        position: "absolute",
        background: ({ theme, color }) =>
            `${alpha(
                color || theme.ControlBackground,
                theme.ControlAlpha,
            )} 0% 0% no-repeat padding-box`,
        color: ({ theme, color }) => foregroundColor(theme, color || theme.ControlBackground),
        border: ({ theme, color }) => [
            [
                theme.BorderWidth,
                "solid",
                darken(color || theme.ControlBackground, theme.BorderValue),
            ],
        ],
        borderRadius: ({ theme }) => Math.min(theme.BorderRadius, 50),
        textAlign: "center",
        fontWeight: "bolder",
    },
    card: {
        backgroundColor: ({ theme, color }) => color || theme.SecondaryColor,
        border: ({ theme, color }) => [
            [
                Math.max(theme.BorderWidth, 1),
                "solid",
                darken(color || theme.SecondaryColor, theme.BorderValue),
            ],
        ],
        borderRadius: ({ theme }) => theme.BorderRadius,
        color: ({ theme, color }) => foregroundColor(theme, color || theme.SecondaryColor),
        position: "absolute",
        textAlign: "center",
        fontWeight: "bolder",
        backgroundSize: "cover",
        backgroundPosition: "center",
        cursor: "grab",

        "&:active": {
            cursor: "grabbing",
        },
    },
});
